import {
  AURORA_CARE_NAV_CDN_ASSETS_LINK_BASE,
  AURORA_CDN_ASSETS_LINK_BASE,
  CDN_ASSETS_LINK_BASE,
} from '@lyrahealth-inc/shared-app-logic/src/features/common/constants/constants'

import AICoachIcon from './aiCoachIcon.svg'
import ConfirmedImage from './confirmed.png'
import DawnBackground from './DawnBackground.png'
import DawnBackgroundMobile from './DawnBackgroundMobile.png'
import DawnBackgroundMobileWeb from './DawnBackgroundMobileWeb.png'
import DawnBackgroundWiderAspectRatio from './DawnBackgroundWiderAspectRatio.png'
import RibbonHeart from './lottie/ribbonAnimation.json'
import MedsConsultationPng from './MedsConsultationPng.png'
import ReferralsImage from './referrals.png'
import ScheduleImage from './schedule.png'
import TreatmentDetailTemplateHeaderDesktopImage from './treatmentDetailTemplateHeader_desktop.png'
import TreatmentDetailTemplateHeaderMobileImage from './treatmentDetailTemplateHeader_mobile.png'
import ToolkitPromotionFamilyImage from './WellnessPromotionFamily.png'
import WellnessToolkitHeaderImage from './WellnessToolkitHeader.png'
import WellnessToolkitHeaderLyraSelectImage from './WellnessToolkitHeaderLyraSelect.png'
import WellnessToolkitMobileHeaderImage from './WellnessToolkitMobileHeader.png'
import WellnessToolkitMobileHeaderLyraSelectImage from './WellnessToolkitMobileHeaderLyraSelect.png'

// CDN imports for specific assets from your list

export { ModeratFonts, PPFragmentFonts } from './fontAssets'

export {
  ToolkitPromotionFamilyImage,
  WellnessToolkitHeaderImage,
  WellnessToolkitHeaderLyraSelectImage,
  WellnessToolkitMobileHeaderLyraSelectImage,
  WellnessToolkitMobileHeaderImage,
  RibbonHeart,
  DawnBackground,
  DawnBackgroundMobile,
  DawnBackgroundMobileWeb,
  DawnBackgroundWiderAspectRatio,
  MedsConsultationPng,
  TreatmentDetailTemplateHeaderDesktopImage,
  TreatmentDetailTemplateHeaderMobileImage,
  AICoachIcon,
  ConfirmedImage,
  ReferralsImage,
  ScheduleImage,
}

export const SelfCareWellnessTopicBackgroundImage = {
  uri: `${CDN_ASSETS_LINK_BASE}/SelfCareWellnessTopicBackground@2x.png`,
}

export const SSOReconciliationVerifyEmailBackgroundImage = {
  uri: `${CDN_ASSETS_LINK_BASE}/SSOReconciliationVerifyEmailBackground.png`,
}
export const CareTeamIllustrationPng = { uri: `${CDN_ASSETS_LINK_BASE}/careTeamIllustration.png` }
export const GraduatedFromActivities = { uri: `${CDN_ASSETS_LINK_BASE}/graduatedFromActivities.png` }
export const LyraSelectSkyBackground = { uri: `${CDN_ASSETS_LINK_BASE}/LyraSelectSkyBackground.png` }
export const NoNewActivities = { uri: `${CDN_ASSETS_LINK_BASE}/noNewActivities.png` }
export const ProviderCalendarCheckmark = { uri: `${CDN_ASSETS_LINK_BASE}/providerCalendarCheckmark.png` }
export const RegistrationCheckEmailAnimation = { uri: `${CDN_ASSETS_LINK_BASE}/registration_check_email_animation.gif` }
export const RegistrationVariantBackground = { uri: `${CDN_ASSETS_LINK_BASE}/registrationVariantBackground.png` }

// Multi-resolution assets from your list
export const HomebaseIllustration = { uri: `${CDN_ASSETS_LINK_BASE}/homebase_illustration@2x.png` }

export const S4CLoadingAnimationMobile = { uri: `${CDN_ASSETS_LINK_BASE}/S4CLoadingAnimationMobile.gif` }
export const S4CLoadingAnimationDesktop = { uri: `${CDN_ASSETS_LINK_BASE}/S4CLoadingAnimationDesktop.gif` }

export const CardMeds = { uri: `${CDN_ASSETS_LINK_BASE}/card_meds@3x.png` }

export const ConstellationCloudsBackgroundMobile = {
  uri: `${CDN_ASSETS_LINK_BASE}/constellationCloudsBackgroundMobile@2x.png`,
}

export const selectHomebaseHeaderCurvedBGDarkMode = {
  uri: `${CDN_ASSETS_LINK_BASE}/selectHomebaseHeaderCurvedBGDarkMode@2x.png`,
}

export const selectHomebaseHeaderCurvedBGDarkModeDesktop = {
  uri: `${CDN_ASSETS_LINK_BASE}/selectHomebaseHeaderCurvedBGDarkModeDesktop.png`,
}

export const CareNavigatorGeneralEntryPointImage = {
  uri: `${CDN_ASSETS_LINK_BASE}/CareNavigatorGeneralEntryPointImage.png`,
}

export const CareNavigatorGeneralEntryPointImageDesktop = {
  uri: `${CDN_ASSETS_LINK_BASE}/CareNavigatorGeneralEntryPointImageDesktop.png`,
}

export const AuroraCareNavigatorGeneralEntryPointImage = {
  uri: `${AURORA_CARE_NAV_CDN_ASSETS_LINK_BASE}/GeneralEntryPoint.png`,
}

export const AuroraCareNavigatorGeneralEntryPointImageDesktop = {
  uri: `${AURORA_CARE_NAV_CDN_ASSETS_LINK_BASE}/GeneralEntryPointDesktop.png`,
}

export const AuroraCareNavigatorZeroResult = {
  uri: `${AURORA_CARE_NAV_CDN_ASSETS_LINK_BASE}/TriageZeroResult.png`,
}

export const AuroraCareNavigatorToolkitFooterImage = {
  uri: `${AURORA_CARE_NAV_CDN_ASSETS_LINK_BASE}/ToolkitFooter.png`,
}

export const CareNavigatorsSquare = {
  uri: `${CDN_ASSETS_LINK_BASE}/CareNavigatorsSquare.png`,
}

export const CareNavigatorsSquareDesktop = {
  uri: `${CDN_ASSETS_LINK_BASE}/CareNavigatorsSquareDesktop.png`,
}

export const AuroraCareNavigatorsSquare = {
  uri: `${AURORA_CDN_ASSETS_LINK_BASE}/AuroraCareNavigatorsSquare.png`,
}

export const AuroraCareNavigatorsSquareDesktop = {
  uri: `${AURORA_CDN_ASSETS_LINK_BASE}/AuroraCareNavigatorsSquareDesktop.png`,
}

export const AuroraHeroFlower = {
  uri: `${AURORA_CDN_ASSETS_LINK_BASE}/provider_avatar_flower_background.png`,
}

export const AuroraHeroPhone = {
  uri: `${AURORA_CDN_ASSETS_LINK_BASE}/person_holding_phone.png`,
}
